import React, { useContext, useEffect } from 'react'
import { AuthSelector } from '../../store/reducers/auth/auth'
import { useSelector, useDispatch } from 'react-redux'
import ChangePassWord from '../../components/auth/changePassWord'
import { ConstContext } from '../../store/context/constContext'
import Toast from 'react-bootstrap/Toast'
import { Layout,Grid } from 'antd';
import SiderMenu from '../../components/navMenu/siderMenu'
import './mainPage.css'
import HeaderNav from '../../components/layout-components/HeaderNav';
import {SIDE_NAV_WIDTH,SIDE_NAV_COLLAPSED_WIDTH,} from '../../configs/ThemeConstant'
import utils from '../../utils';
import MobileNav from '../../components/layout-components/MobileNav'
import ScrollView from 'devextreme-react/scroll-view';

const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;

function MainLayout({ children }) {

    const dispatch = useDispatch()
    const {
        showToast: { show, message, type },
        setShowToast,
        collapsed,
        isMobile,
        setisMobile
    } = useContext(ConstContext)

    const AuthSelectors = useSelector(AuthSelector)
    const screens = utils.getBreakPoint(useBreakpoint());
    useEffect(() =>
    {
        setisMobile(screens.length === 0 ? false : !screens.includes('lg'))
    }, [screens])
    const getLayoutGutter = () => {
        if (isMobile) {
            return 0
        }
        return collapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
    }
    return (
        <>
            <Layout>
                <HeaderNav isMobile={isMobile} navCollapsed={collapsed} direction='ltr' />
                <Layout className="app-container">
                    {!isMobile ?
                        <ScrollView id="scrollview" showScrollbar={'onHover'}>
                            <Sider
                                className={`side-nav`}
                                width={250}
                                collapsed={collapsed}>
                                <SiderMenu />
                            </Sider>
                        </ScrollView> : null}
                    <Layout className="app-layout" style={{ paddingLeft: getLayoutGutter() }}>
                        <div className={`app-content`}>
                            <Content>
                                {children}
                            </Content>
                        </div>
                    </Layout>
                </Layout>
            </Layout>
            {isMobile && <MobileNav />}
            {AuthSelectors.showModalChangePass && <ChangePassWord />}
            <Toast
                show={show}
                style={{ position: 'fixed', top: '20%', right: '10px' }}
                className={`bg-${type} text-white`}
                onClose={() => setShowToast({
                    show: false,
                    message: '',
                    type: ''
                })}
                delay={5000}
                autohide
            >
                <Toast.Body>
                    <strong>{message}</strong>
                </Toast.Body>
            </Toast>
        </>
    )
}
export default MainLayout
